import { HEIGHT_CONSTANT } from '@utils/constants'
import { publicImages } from '@utils/shared'
import { StylesClasses, commonStyles, createStyles } from '@utils/styles'
import { resourceListNewLetterWrapperStyles } from '@utils/styles/model/styles.const'

const styles = createStyles({
  drawer: {
    '& .MuiDrawer-paper': {
      width: '95dvw',
      padding: 0,
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
    },
  },
  stickyHeader: {
    ...commonStyles.flexSpace(),
    position: 'sticky',
    top: 0,
    zIndex: 1,
    backgroundColor: 'white',
    padding: '1rem',
    borderBottom: '1px solid',
    borderColor: 'border.light',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
  },
  scrollableContent: {
    flex: 1,
    overflow: 'auto',
    padding: '1rem',
    '&::-webkit-scrollbar': {
      width: '4px',
    },
    '&::-webkit-scrollbar-track': {
      background: 'transparent',
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#ccc',
      borderRadius: '2px',
    },
    '&::-webkit-scrollbar-thumb:hover': {
      background: '#aaa',
    },
  },
  contentWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    overflow: 'hidden',
  },

  headingWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '20px',
    flexWrap: 'wrap',
  },

  category: {
    display: 'flex',
    gap: 1,
    backgroundColor: 'grey.950',
    borderRadius: '8px',
  },

  chip: {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
    height: '32px',
    width: 'max-content',
    borderRadius: '24px',
    p: '8px 12px',
    typography: 'caption1',
    cursor: 'pointer',
    backgroundColor: 'neutral.900',
    color: 'neutral.white',

    '&:hover': {
      backgroundColor: 'neutral.950',
      // color: 'text.secondary',
    },
  },

  tabDivider: {
    height: '32px',
    mx: 1,
  },

  cards: {
    display: 'flex',
    flexWrap: 'wrap',
    rowGap: '42px',
    columnGap: '3.5%',
    height: 'fit-content',
    overflowY: 'auto',
    msOverflowStyle: 'none',
    scrollbarWidth: 'none',
  },

  btn: {
    textDecoration: 'none',
    color: 'inherit',
  },
  pageBox: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '10px',
  },

  limitText: {
    color: 'neutral.600',
    mr: 1,
  },

  limitWrapper: {
    display: 'flex',
    alignItems: 'center',
  },

  cardsWrapper: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    marginTop: '-16px',
  },
  categoryFilterWrapper: {
    borderRadius: '8px',
    padding: '4px 8px',
    width: 'fit-content',
    height: 'unset',
  },
  selectedCategoryFilterWrapper: {
    borderColor: 'primary.main',
    backgroundColor: 'custom.selectedChipBackground',
  },
  blogsWrapper: {
    display: 'flex',
    flexDirection: 'row',
    gap: '16px',
    position: 'relative',
  },
  buttonGroup: {
    '& .MuiButton-root': {
      border: '1px solid',
      borderColor: 'border.light',
      backgroundColor: 'background.paper',
      whiteSpace: 'nowrap',
      minWidth: 'fit-content',
      ':hover': {
        border: '1px solid',
        borderColor: '#FFFFFF1A',
      },
    },
    backgroundColor: 'background.default',
    minWidth: '100%',
    overflow: 'scroll',
    scrollbarWidth: 'none',
  },
  filterWrapper: {
    backgroundColor: 'background.paper',
    borderRadius: '16px',
    padding: '24px 16px',
    maxWidth: {
      xs: '100%',
      sm: '100%',
      md: '318px',
    },
    minWidth: {
      xs: '100%',
      sm: '100%',
      md: '318px',
    },
    gap: '24px',
    maxHeight: 'fit-content',
    border: '1px solid',
    borderColor: 'border.dark',
    overflow: 'hidden',
    boxShadow: 2,
  },
  textField: {
    // height: '40px',
    borderRadius: '8px',
    // '& .MuiOutlinedInput-root': {
    //   borderRadius: '8px',
    //   '& fieldset': {
    //     border: '1px solid',
    //     borderColor: 'border.dark',
    //   },
    // },
    // '& .MuiInputBase-input': {
    //   padding: '8px 12px',
    //   borderRadius: '8px',
    // },

    maxWidth: '400px',
    width: '100%',
    ...commonStyles.textField,
    backgroundColor: '#FFFFFF0D',
  },
  mileStoneSection: {},
  divider: {
    width: '100%',
    marginBottom: '-4px',
  },
  accordionWrapper: {
    padding: '3px',
  },
  accordionDrawer: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '14px',
    marginTop: '16px',
    maxHeight: '200px',
    overflowY: 'auto',
    scrollbarWidth: 'none',
    padding: '4px 0px 0px 1px',
  },
  milesStoneCardWrapper: {
    minHeight: '248px',
    minWidth: '100%',
  },
  milesStoneTitle: {
    fontSize: '1.5rem',
    lineHeight: '2rem',
  },
  milesStoneDescription: {
    fontSize: '0.8rem',
    lineHeight: '1.5rem',
  },
  milesSoneTitleDesc: {
    gap: '0.5rem',
    maxWidth: '602px',
  },
  newsLetterSectionWrapper: {
    maxWidth: {
      xs: '100%',
      sm: '100%',
      md: '100%',
    },
    borderRadius: '24px',
    overflow: 'hidden',
    position: 'relative',
    '& .grecaptcha-badge': {
      maxWidth: '100%',
    },
    '& iframe': {
      maxWidth: '100%',
    },
    '& .rc-anchor-pt': {
      visibility: 'visible',
      display: 'block',
    },
    backgroundColor: 'common.black',
  },
  newLetterSectionButton: {
    maxWidth: 'fit-content',
    padding: '0px 12px',
    marginLeft: '-4px',
    fontSize: '0.9rem',
  },
  newsLetterSectionInfoWrapper: {
    flexDirection: 'column',
    gap: '20px',
    width: '254px',
  },
  typography: {
    fontSize: '1.5rem',
    lineHeight: '1.5rem',
  },
  newsLetterContentWrapper: {
    maxWidth: 'unset',
  },
  bgImage: {
    display: 'none',
  },

  leftContainer: {
    width: {
      md: '318px',
      sm: '100%',
      xs: '100%',
    },
    display: {
      xs: 'none',
      sm: 'block',
    },
  },
  stickyWrapper: {
    position: 'sticky',
    top: `${HEIGHT_CONSTANT.HEADER_HEIGHT - 30}px`,
    width: {
      md: '100%',
      sm: '100%',
    },
  },
  milestoneCardContent: {
    marginBlock: '12px',
    gap: {
      xs: '16px',
      md: '24px',
    },
    border: 'none',
  },
  mileStoneTitle: {
    fontSize: '1.5rem',
    lineHeight: '2rem',
  },
  mileStoneDescription: {
    fontSize: '1.02rem',
    lineHeight: '1.5rem',
    color: 'text.secondary',
    marginTop: '-0.5rem',
  },
  leftView: {
    minWidth: {
      xs: '100%',
      md: 'unset',
    },
    justifyContent: 'space-between',
  },
  image: {
    maxWidth: {
      xs: '100%',
      md: '240px',
    },
  },
  blogData: {
    justifyContent: 'space-between !important',
  },
})

export type StylesClassNames = StylesClasses<typeof styles>
export default styles

// Common newsletter styles
export const getNewsletterStyles = () => ({
  wrapper: resourceListNewLetterWrapperStyles,
  formWrapper: {
    flexDirection: 'column',
    gap: '12px',
  },
  button: {
    width: 'fit-content',
    height: '40px !important',
    fontSize: '14px',
    borderRadius: '8px',
    marginTop: '12px',
  },
  image: {
    display: 'none',
  },
  wrapperHeader: {
    marginTop: {
      xs: 'unset',
      sm: '-4px',
    },
  },
  textFieldWrapper: {
    width: {
      xs: '100%',
      sm: '260px',
    },
  },
})

export const getNewsletterWrapperHeaderStyles = () => ({
  textWrapper: {
    gap: '12px !important',
  },
  root: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '12px',
  },
})
